'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { BumpableItemPreCheckoutModel, clickEvent } from '@marketplace-web/vas/vas-data'

import useStartBumpCheckout from '../../hooks/useStartBumpCheckout'

type Props = {
  itemId: number
  canBump: boolean | undefined
}

const ProfileItemBumpButton = ({ itemId, canBump }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('item.actions')
  const { startCheckout } = useStartBumpCheckout()

  function handleOnClick() {
    const selectedItem: BumpableItemPreCheckoutModel = {
      id: itemId,
      title: null,
      thumbnail: null,
    }
    startCheckout(selectedItem)

    track(
      clickEvent({
        target: 'push_up_item',
        targetDetails: `${itemId}`,
        screen: 'current_user_profile',
      }),
    )
  }

  return (
    <Button
      disabled={!canBump}
      size="small"
      text={translate('bump')}
      onClick={handleOnClick}
      testId="bump-button"
    />
  )
}

export default ProfileItemBumpButton
